import { useCallback, useRef } from 'react';

/**
 * Hook personalizado para implementar debounce
 * @param callback - Función a ejecutar después del delay
 * @param delay - Tiempo de espera en milisegundos
 * @returns Función debounced
 */
export const useDebounce = <T extends (...args: any[]) => void>(
  callback: T,
  delay: number
): T => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedCallback = useCallback(
    (...args: Parameters<T>) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  ) as T;

  return debouncedCallback;
};